import HeaderSpan from './HeaderSpan'
import SessionItem from './SessionItem'
import { langSessionList } from '../assets/langSessionList'
import { useLang } from '../utils/hooks'
import { sessionColors } from '../assets/colors'
import { useMobile } from '../utils/hooks.jsx'

const SessionList = ({
  list,
  handleSelectNewItem,
  handleRemoveItem,
  handleModifyItem,
  handleOnAdd,
  handleSort,
  restricted,
  handleSearchInputChange,
  handleEscSearch,
  buttonsActive,
  addAuthorized,
  disabledDemo,
  textClass,
}) => {
  const { mobile } = useMobile()
  const background = sessionColors.headerCl
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langSessionList.fr : langSessionList.eng
  const listSessions = list.listSessionsPage
  const sortOrder = list.sortOrder.isReverse
  const sortType = list.sortOrder.sortType
  const searchInput = list.searchInput
  const oneItemSelected =
    listSessions
      .map(function (e) {
        return e.bg
      })
      .indexOf('selected') !== -1

  const onSort = (columnType) => {
    if (!buttonsActive) return
    handleSort(columnType)
  }

  const handleClickOnItem = (event) => {
    if (!buttonsActive) return
    let itemId = event.target.id
    const item = listSessions.filter((session) => itemId === session._id)[0]
    handleSelectNewItem(item)
  }

  const onRemoveItem = () => {
    handleRemoveItem()
  }

  const onSearchInputChange = (event) => {
    if (!buttonsActive) return
    handleSearchInputChange(event)
  }

  const onKey = (e) => {
    if (!buttonsActive) return
    if (e.key === 'Escape') handleEscSearch()
  }

  // const w_a = ['50', '25', '11', '14']
  const w_a = !mobile ? ['60', '25', '15'] : ['70', '30']

  let i = 0
  let row_i = 0

  return (
    <div className={'content ' + textClass}>
      <div className="block">
        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <div className="field is-grouped">
                <p className="control">
                  <AddButton
                    onAdd={handleOnAdd}
                    choosenLang={choosenLang}
                    buttonsActive={buttonsActive}
                    addAuthorized={addAuthorized}
                    title={
                      addAuthorized === true
                        ? ''
                        : choosenLang.maxSessionsReached
                    }
                    disabledDemo={disabledDemo}
                  />
                </p>
                <p className="control">
                  <ModifyButton
                    onModifyItem={handleModifyItem}
                    isDisabled={!oneItemSelected}
                    choosenLang={choosenLang}
                    buttonsActive={buttonsActive}
                  />
                </p>
                <p className="control">
                  <RemoveButton
                    onRemoveItem={onRemoveItem}
                    isDisabled={!oneItemSelected}
                    choosenLang={choosenLang}
                    buttonsActive={buttonsActive}
                    disabledDemo={disabledDemo}
                  />
                </p>
              </div>
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              {list.initialData.length > 0 && (
                <div className="field is-horizontal">
                  <div className="field-label is-small">
                    <label className="label">{choosenLang.search} </label>
                  </div>
                  <div className="field-body">
                    <div className="field">
                      <p className="control">
                        <input
                          className="input is-small"
                          type="search"
                          value={searchInput}
                          onChange={onSearchInputChange}
                          onKeyDown={onKey}
                        />
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {list.initialData.length > 0 ? (
        <>
          <div className={'block ' + textClass}>
            <div style={{ display: 'flex', width: '100%' }}>
              <HeaderSpan
                headerTitle={choosenLang.session}
                background={background}
                columnType={'SESSION_SORT'}
                sortType={sortType}
                sortOrder={sortOrder}
                w={w_a[i]}
                handleOnClick={onSort}
                align={'left'}
              />
              <HeaderSpan
                headerTitle={!mobile ? choosenLang.dateTime : choosenLang.date}
                background={background}
                columnType={'DATE_SORT'}
                sortType={sortType}
                sortOrder={sortOrder}
                w={w_a[++i]}
                handleOnClick={onSort}
                align={'left'}
              />
              {/* <HeaderSpan
                headerTitle={choosenLang.duration}
                background={background}
                columnType={'DUREE_SORT'}
                sortType={sortType}
                sortOrder={sortOrder}
                w={w_a[++i]}
                handleOnClick={onSort}
                align={'center'}
              /> */}
              {!mobile && (
                <HeaderSpan
                  headerTitle={choosenLang.wind}
                  background={background}
                  columnType={''}
                  sortType={null}
                  sortOrder={null}
                  w={w_a[++i]}
                  handleOnClick={onSort}
                  align={'center'}
                />
              )}
            </div>
          </div>
          <div className="list-medium-container">
            {listSessions.map((oneSession) => {
              row_i++
              return (
                <SessionItem
                  key={oneSession._id}
                  session={oneSession}
                  onClick={handleClickOnItem}
                  isGrey={row_i % 2 === 1}
                  isSelected={oneSession.bg}
                  wA={w_a}
                  restricted={restricted}
                ></SessionItem>
              )
            })}
          </div>
        </>
      ) : (
        <div className="notification is-warning is-light is-notif">
          {choosenLang.noSessions}
        </div>
      )}
    </div>
  )
}

const AddButton = ({
  onAdd,
  choosenLang,
  buttonsActive,
  disabledDemo,
  addAuthorized,
}) => {
  return (
    <button
      className="button is-info is-normal has-text-white has-text-weight-semibold "
      onClick={onAdd}
      disabled={disabledDemo ? disabledDemo : !buttonsActive || !addAuthorized}
      title={
        disabledDemo
          ? choosenLang.registeredOnly
          : addAuthorized
            ? ''
            : choosenLang.maxSessionsReached
      }
    >
      <span>{choosenLang.add}</span>
    </button>
  )
}

const RemoveButton = ({
  onRemoveItem,
  isDisabled,
  choosenLang,
  buttonsActive,
  disabledDemo,
}) => {
  return (
    <button
      className="button is-info  is-normal has-text-white has-text-weight-semibold "
      onClick={onRemoveItem}
      disabled={isDisabled || !buttonsActive || disabledDemo}
      title={disabledDemo ? choosenLang.registeredOnly : ''}
    >
      {choosenLang.delete}
    </button>
  )
}

const ModifyButton = ({
  onModifyItem,
  isDisabled,
  choosenLang,
  buttonsActive,
}) => {
  return (
    <button
      className="button is-info  is-normal has-text-white has-text-weight-semibold "
      onClick={onModifyItem}
      disabled={isDisabled || !buttonsActive}
    >
      {choosenLang.modify}
    </button>
  )
}

export default SessionList
